module.exports = __webpack_public_path__ + "img/ic_menu_logout.102f37c7.svg";